import { get, post } from '../../utils/http';

export const fetchXeroContacts = ({ accountId }) => get(`/accounts/${accountId}/xero/contacts`);

export const createXeroContact = ({ accountId, name }) => post(`/accounts/${accountId}/xero/contacts`, { name });
